import { displaySoftHyphens } from "#/_packages/umbrella/utils/soft-hyphens";
import { cn } from "tailwind-variants";
import type { Error404UmbPageContentResponseModel } from "#/_generated/umbraco/delivery-api/models";
import { useGetSiteSettings } from "#/_packages/umbrella/hooks/useGetSiteSettings.ts";
import { BlockGrid } from "#/_packages/umbrella/integrations/umbraco/property-components/block-grid.tsx";
import type { PageContent } from "#/_packages/umbrella/types";

export default function PageNotFoundUmbPage({
	content,
}: PageContent<Error404UmbPageContentResponseModel>) {
	const siteSettings = useGetSiteSettings();
	const properties = content.properties;
	const pageTitle = displaySoftHyphens(
		properties?.heading || content.name || "",
	);
	const mainContentContainer = toMainContentContainerClass(
		siteSettings?.mainContentContainer,
	);
	const mainContentContainerAlignment = toMainContentContainerAlignmentClass(
		siteSettings?.mainContentContainerAlignment,
	);

	return (
		<>
			{!properties?.hidePageTitle && pageTitle ? (
				<div className="page-title-wrapper">
					<div
						className={cn(mainContentContainer, mainContentContainerAlignment)}
					>
						<h1 className="page-title">{pageTitle}</h1>
					</div>
				</div>
			) : null}

			<div className={properties?.noVerticalSpacing ? "no-row-gap" : undefined}>
				<BlockGrid
					noVerticalSpacing={content.properties?.noVerticalSpacing ?? false}
					contentArea={properties?.blockGrid}
				/>
			</div>
		</>
	);
}

function toMainContentContainerClass(value?: string | null) {
	switch (value) {
		case "fluidToSM":
			return "container-sm";
		case "fluidToMD":
			return "container-md";
		case "fluidToLG":
			return "container-lg";
		case "fluidToXL":
			return "container-xl";
		case "fluidToXXL":
			return "container-xxl";
		case "alwaysFluid":
			return "container-fluid";
		default:
			return "container ";
	}
}

function toMainContentContainerAlignmentClass(value?: string | null) {
	switch (value) {
		case "start":
			return "container-start";
		case "end":
			return "container-end";
		default:
			return "";
	}
}
